import './SignUpTitle.css';
import {isMobile} from 'react-device-detect';

const SignUpTitle = (props) => {
  const { stepNumber } = props;
  let pageName = "";
  switch (stepNumber) {
    case 1:
      pageName = "Company Information";
      break;
    case 2:
      pageName = "Contact Information";
      break;
    case 3:
      pageName = "Payment Information";
      break;
  }

  const renderProgress = (step) => {
    const elements = [];
    for (let i = 1; i <= 3; i++) {
      elements.push(
        <div key={`circle-${i}`} className={i <= step ? 'blueCir' : 'grayCir'}></div>
      );
      if (i < 3) {
        elements.push(
          <div key={`line-${i}`} className={i < step ? 'blueLine' : 'grayLine'}></div>
        );
      }
    }
    return elements;
  };

  return (
    <div className='sign-container'>
      <div className='first-line'>Create a Voyce Account</div>
      <div className='second-line'>STEP {stepNumber} of 3</div>
      <div className='third-line'>{pageName}</div>
      <div id="cirLine">
        {renderProgress(stepNumber)}
      </div>
    </div>
  );
};


export default SignUpTitle;
